let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Axyo")).then(() => parcelRequire('Qj9U8'));